<div class="relative w-full flex flex-row justify-between">
  <p class="text-xs lg:text-base text-white font-semibold mb-1 lg:mb-2">Sticker Orders</p>
  <div
    class="relative flex flex-row gap-1 lg:gap-2 text-slate-700 dark:text-slate-500 text-[10px] lg:text-base"
  >
    <p>Edit</p>
    <p>Delete</p>
  </div>
</div>
<div
  cdkDropList
  cdkDropListOrientation="vertical"
  (cdkDropListDropped)="drop($event)"
  class="flex-none flex flex-col gap-1 w-full max-h-64 lg:max-h-96 rounded bg-white/20 mb-1 lg:mb-2 overflow-x-hidden overflow-y-auto"
>
  @for (attachSticker of attachStickers(); track $index) {
    <div
      class="relative flex-none flex flex-row justify-between items-center w-full bg-gray-700 rounded overflow-hidden"
      cdkDrag
    >
      <div
        class="absolute top-0 w-full h-full z-[1] opacity-50"
        [ngStyle]="{
          backgroundImage: 'url(' + attachSticker.image + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }"
      ></div>
      <div class="relative flex flex-row gap-1 lg:gap-2 items-center px-1 lg:px-3">
        <button class="flex-none w-4 h-4 z-10">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
            <path
              d="M360-160q-33 0-56.5-23.5T280-240q0-33 23.5-56.5T360-320q33 0 56.5 23.5T440-240q0 33-23.5 56.5T360-160Zm240 0q-33 0-56.5-23.5T520-240q0-33 23.5-56.5T600-320q33 0 56.5 23.5T680-240q0 33-23.5 56.5T600-160ZM360-400q-33 0-56.5-23.5T280-480q0-33 23.5-56.5T360-560q33 0 56.5 23.5T440-480q0 33-23.5 56.5T360-400Zm240 0q-33 0-56.5-23.5T520-480q0-33 23.5-56.5T600-560q33 0 56.5 23.5T680-480q0 33-23.5 56.5T600-400ZM360-640q-33 0-56.5-23.5T280-720q0-33 23.5-56.5T360-800q33 0 56.5 23.5T440-720q0 33-23.5 56.5T360-640Zm240 0q-33 0-56.5-23.5T520-720q0-33 23.5-56.5T600-800q33 0 56.5 23.5T680-720q0 33-23.5 56.5T600-640Z"
            />
          </svg>
        </button>
        <p class="text-[10px] lg:text-[13px] text-white font-semibold py-0.5 lg:py-1.5 z-[2]">
          {{ attachSticker.title }}
        </p>
      </div>
      <div class="flex flex-row gap-1 lg:gap-2 z-[2] px-1 lg:px-3 py-0.5 lg:py-1.5">
        <button
          class="p-1 lg:p-2 flex-none flex h-full aspect-square justify-center items-center bg-black/40 rounded-full group hover:bg-black/80 active:bg-black"
          (click)="onClickEditAttachSticker($index)"
        >
          <div
            class="flex justify-center items-center text-xs lg:text-sm text-white/60 group-hover:text-white/80 group-active:text-white"
          >
            <mat-icon [inline]="true">edit</mat-icon>
          </div>
        </button>
        <button
          class="p-1 lg:p-2 flex-none flex h-full aspect-square justify-center items-center bg-black/40 rounded-full group hover:bg-black/80 active:bg-black"
          (click)="onClickRemoveAtttachSticker($index)"
        >
          <div
            class="flex justify-center items-center text-xs lg:text-sm text-white/60 group-hover:text-white/80 group-active:text-white"
          >
            <mat-icon [inline]="true">delete</mat-icon>
          </div>
        </button>
      </div>
    </div>
  }
</div>
